<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="pointId" label="巡查点位">
              <el-select v-model="formData.pointId" clearable @change="changePoint" filterable placeholder="请选择巡查点位">
                <el-option v-for="(item, index) of pointList" :value="item.pointId" :label="item.pointName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="inspectDate" label="巡查日期">
              <el-date-picker v-model="formData.inspectDate" placeholder="请选择巡查日期" type="date" clearable
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="taskResult" label="巡查结果">
              <el-select v-model="formData.taskResult" clearable filterable placeholder="请选择巡查结果">
                <el-option v-for="(item, index) of resultArr" :value="item.value" :label="item.label"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-form-item prop="resultList" label="检查项">

            <el-table size="mini" class="table-form" stripe border :data="formData.resultList">
              <el-table-column show-overflow-tooltip min-width="100" label="检查项" prop="itemName">

              </el-table-column>
              <el-table-column show-overflow-tooltip min-width="140" label="检查结果" prop="checkResult">
                <template v-slot="{ $index }">
                  <el-form-item class="table-form-item" :prop="'resultList.' + $index + '.checkResult'" label=""
                    label-width="0" :rules="[
                      {
                        required: true,
                        message: '请选择检查结果',
                        trigger: ['blur', 'change']
                      }
                    ]"> <el-radio-group v-model="formData.resultList[$index].checkResult">
                      <el-radio label="1">正常</el-radio>
                      <el-radio label="2">异常</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </template>
              </el-table-column>

            </el-table>

          </el-form-item>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="remark" label="备注">
              <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="formData.remark">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap">
                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <i class="el-icon-error close-icon" @click="delImage(formData.fileList.indexOf(item))"></i>
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>

                <el-upload class="upload-demo" :show-file-list="false" :action="$apis.common.uploadUrl"
                  :on-success="handleSuccess" :before-upload="beforeUpload" list-type="picture-card">
                  <i class="el-icon-plus"></i>
                  <div slot="tip" class="el-upload__tip">
                    图片大小不能超过10MB~
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>
    <image-viewer :visible.sync="dialogVisible" :initial-index="currentImageIndex" :url-list="imageList"></image-viewer>

  </div>
</template>

<script>
import ImageViewer from '@/components/ImageViewer.vue'

export default {
  name: 'inspectionRecord',
  components: { ImageViewer },

  data () {
    return {
      formData: {
        pointId: '',
        inspectDate: '',
        taskResult: '',
        remark: '',
        fileList: [],
        resultList: []
      },
      resultArr: [
        {
          label: '正常',
          value: '1'
        },
        {
          label: '异常',
          value: '2'
        }
      ],
      pointList: [],
      currentImageIndex: 0,
      dialogVisible: false,
      rules: {
        pointId: [
          {
            required: true,
            message: '请输入巡查点位',
            trigger: ['blur', 'change']
          }
        ],
        inspectDate: [
          {
            required: true,
            message: '请选择巡检日期',
            trigger: ['blur', 'change']
          }
        ],
        taskResult: [
          {
            required: true,
            message: '请选择巡检结果',
            trigger: ['blur', 'change']
          }
        ],
        resultList: [
          {
            required: true,
            message: '请选择检查项的检查结果',
            trigger: ['blur', 'change']
          }
        ]

      },
      loading: false

    }
  },
  created () {
    this.loadPoint()
    if (this.taskId) {
      this.loadData()
    }
  },
  computed: {
    taskId () {
      return this.$route.query.taskId
    },
    pointType () {
      return this.$route.query.pointType
    },
    formatFileList () {
      return this.$attachmentFiles(this.formData.fileList).map(file => {
        return {
          name: file.fileName,
          url: file.filePrefix + file.fileUrl
        }
      })
    },
    imageList () {
      return this.formatFileList.filter(item => {
        console.log('item', item)
        return item.name && ['.jpg', '.png', '.jpeg', '.gif'].includes(item.name.substring(item.name.lastIndexOf('.')).toLowerCase())
      })
    },
    fileImgUrl() {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {
    changePoint (val) {
      if (val) {
        this.$axios
          .get(this.$apis.inspectionPoint.selectPaInspectPointByPointId, {
            params: { pointId: val }
          })
          .then(res => {
            res.itemLis = res.itemLis ? res.itemLis : []
            this.formData.resultList = res.itemLis.map(item => {
              return {
                itemName: item,
                checkResult: ''
              }
            })
          })
      } else {
        this.formData.resultList = []
      }
    },
    loadPoint () {
      this.$axios.get(this.$apis.inspectionPoint.selectPaInspectPointByPage, {
        params: {
          pointType: this.pointType
        }
      }).then(res => {
        this.pointList = res.list || []
      })
    },
    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.inspectionRecord.selectPaInspectTaskByTaskId, {
          params: { taskId: this.taskId }
        })
        .then(res => {
          res.itemLis = res.itemLis ? res.itemLis : []
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    onPreview (file) {
      console.log('file', file)
      if (file.name && ['.jpg', '.png', '.jpeg', '.gif'].includes(file.name.substring(file.name.lastIndexOf('.')).toLowerCase())) {
        this.currentImageIndex = this.imageList.findIndex(url => url.name === file.name)
        this.dialogVisible = true
      } else {
        window.open(file.url, '_blank')
      }
    },
    handleSuccess (res) {
      this.formData.fileList.push(res.data)
    },
    delImage (index) {
      this.formData.fileList.splice(index, 1)
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          const arrData = this.formData.resultList.filter(item => !item.checkResult)
          if (arrData.length > 0) {
            this.$message.error('检查项中检查结果存在未选数据，请检查！')
            return
          }
          this.loading = true

          const url = this.$apis.inspectionRecord.insertPaInspectTask
          // if (this.taskId) {
          //   url = this.$apis.inspectionRecord.updatePaInspectPoint
          // }

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}

.table-form {
  .table-form-item {
    padding: 10px 0;

    ::v-deep .el-form-item__content {
      .el-form-item__error {
        transform: translateY(-10px);
      }
    }

  }

}
</style>
